(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('UniversityConnectScheduleController', UniversityConnectScheduleController);

    UniversityConnectScheduleController.$inject = ['$state', '$stateParams', '$uibModal', 'VirtualFairService'];

    function UniversityConnectScheduleController($state, $stateParams, $uibModal, VirtualFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expo                  = [];
        vm.expoSelected          = [];
        vm.selectExpo            = selectExpo;
        vm.users                 = [];
        vm.getByFilter           = getByFilter;
        vm.generateSchedule      = generateSchedule;
        vm.userTypeSelected      = {id: 'exhibitors', name : 'Exhibitors'};
        vm.userTypes             = [{id: 'exhibitors', name : 'Exhibitors'},{id: 'local_universities', name : 'Local Universities'}];
        vm.virtualFairId         = false;
        vm.openScheduleModal     = openScheduleModal;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;      

        activate();

        if ($state.current.data.generateSchedules == true) {
            if ($stateParams.hasOwnProperty('id')) { 
                vm.generateSchedule($stateParams.id);
            }
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            vm.query = {};
            vm.query['type'] = 'university_connect';

            VirtualFairService.getAll(vm.query).then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.query = {};
            vm.query['virtual_fair_id'] = vm.expoSelected.id;
            vm.query['user_type']       = vm.userTypeSelected.id;
            vm.query['page']            = vm.page;
            vm.flag                     = false;

            VirtualFairService.findByUniversityConnect(vm.query).then(function(response) {
                vm.flag = true;
                vm.users = response.data.userProfiles;
                vm.totalItems = response.data.expoUsers.total;
                vm.itemsPerPage = response.data.expoUsers.per_page;
                vm.virtualFairId = vm.query['virtual_fair_id'];
                vm.setPage(response.data.expoUsers.current_page);

            }).catch(function(err) {
            });
        }

        function generateSchedule(virtual_fair_id) {
            VirtualFairService.generateScheduleUniversityConnect(virtual_fair_id).then(function(response) {
                
                $state.go("root.virtualfair.universityConnect.schedules");

            }).catch(function(err) {
            });
        }

        function openScheduleModal(user_id, user_token, user_name) {

            $uibModal.open({
                templateUrl: 'templates/virtualfairs/university-connect/schedule/show/show.html',
                controller: 'UniversityConnectShowScheduleController',
                controllerAs:'universityConnectShowSchedule',
                resolve:
                {
                    user : function () {
                        vm.user = {};

                        vm.user['user_id'] = user_id;
                        vm.user['user_token'] = user_token;
                        vm.user['user_name'] = user_name;
                        vm.user['virtual_fair_id'] = vm.virtualFairId;

                        vm.user['user_type'] = 'user';
                        if (vm.userTypeSelected.id == 'exhibitors') {
                            vm.user['user_type'] = 'exhibitor';
                        }

                        return vm.user;
                    }
                }
            });

        }
    }

})();